import { FC, PropsWithChildren, ReactNode } from 'react';

export interface ShowableProps {
	show?: unknown;
	hide?: unknown;
	children?: ReactNode | (({ isShown }: { isShown: boolean }) => ReactNode);
}

export const Showable: FC<ShowableProps> = ({ children, ...rest }) => {
	const isShown = getIsShown(rest);

	if (isShown) {
		// call children function only if shown is true to avoid unnecessary children calculations
		return <>{typeof children === 'function' ? (isShown ? children({ isShown }) : undefined) : children}</>;
	}

	return <></>;
};

function getIsShown ({ show = false, ...rest }: { show?: unknown; hide?: unknown }): boolean {
	if ('hide' in rest) {
		show = !rest.hide;
	}

	return !!show;
}

export default Showable;
